// extracted by mini-css-extract-plugin
module.exports = {"nav":"GoodfyndSitesHeader_nav___8uX_","user-menu":"GoodfyndSitesHeader_user-menu__8FguO","user-menu-anchor":"GoodfyndSitesHeader_user-menu-anchor__mUIBb"};